import ListView from "../../../components/listView/ListView";
import Page from "../../../components/pageView/Page";
import WidgetPage from "../../../components/widgetPage/WidgetPage";
import StepView from "../../../components/stepView/StepView";
import DrillDownPage from "../../../components/drillDownView/DrillDownPage";

const routesInventory = [
  {
    path: "/inventory",
    element: WidgetPage,
    props: {
      type: "inventory",
      draggable: false,
      resizable: false,
    }
  },
  {
    path: "/inventory/product",
    element: ListView,
    props: {
      type: "productList",
    }
  },
  {
    path: "/inventory/product/:id/itemPrice/new",
    element: Page,
    props: {
      type: "itemPricePageNew",
      options: { mode: "new", load: false, createFromEntity: 'product' },
    }
  },
  {
    path: "/inventory/product/:id/itemPrice/:id2",
    element: Page,
    props: {
      type: "itemPricePage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/product/:id/supplierItem/new",
    element: Page,
    props: {
      type: "supplierItemPageNew",
      options: { mode: "new", load: false, createFromEntity: 'product' },
    }
  },
  {
    path: "/inventory/product/:id/supplierItem/:id2",
    element: Page,
    props: {
      type: "supplierItemPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/product/:id",
    element: Page,
    props: {
      type: "productMultiPage",
      options: { mode: "edit", load: true, onMount: 'collapse' },
    }
  },
  {
    path: "/inventory/product/new",
    element: Page,
    props: {
      type: "productPage",
      options: { mode: "new", load: false },
    }
  },
  {
    path: "/inventory/warehouse",
    element: ListView,
    props: {
      type: "warehouseList",
    }
  },
  {
    path: "/inventory/warehouse/new",
    element: Page,
    props: {
      type: "warehousePage",
      options: { mode: "new", load: false },
    }
  },
  {
    path: "/inventory/warehouse/:id",
    element: Page,
    props: {
      type: "warehouseTabPage",
      options: { mode: "edit", load: true, onMount: 'collapse' }
    }
  },
  {
    path: "/inventory/warehouse/:id/hall/new",
    element: Page,
    props: {
      type: "hallPage",
      options: { mode: "new", load: false },
    }
  },
  {
    path: "/inventory/warehouse/:id/hall/:id2",
    element: Page,
    props: {
      type: "hallPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/rack",
    element: ListView,
    props: {
      type: "rackList",
    }
  },
  {
    path: "/inventory/rack/:id",
    element: Page,
    props: {
      type: "rackPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/rack/new",
    element: Page,
    props: {
      type: "rackPage",
      options: { mode: "new", load: false },
    }
  },
  {
    path: "/inventory/location",
    element: ListView,
    props: {
      type: "locationList",
    }
  },
  {
    path: "/inventory/location/:id",
    element: Page,
    props: {
      type: "locationMultiPage",
      options: { mode: "edit", load: true, onMount: 'collapse' },
    }
  },
  {
    path: "/inventory/adjustment",
    element: ListView,
    props: {
      type: "stockAdjustmentList",
    }
  },
  {
    path: "/inventory/adjustment/:id",
    element: Page,
    props: {
      type: "stockAdjustmentPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/adjustment/new",
    element: Page,
    props: {
      type: "stockAdjustmentPage",
      options: { mode: "new", load: false },
    }
  },
  {
    path: "/inventory/movement",
    element: ListView,
    props: {
      type: "stockMovementList",
    }
  },
  {
    path: "/inventory/movement/new",
    element: Page,
    props: {
      type: "stockMovementPage",
      options: { mode: "new", load: false },
    }
  },
  {
    path: "/inventory/movement/:id",
    element: Page,
    props: {
      type: "stockMovementPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/shipment",
    element: ListView,
    props: {
      type: "stockShipmentList",
    }
  },
  {
    path: "/inventory/shipment/new",
    element: Page,
    props: {
      type: "stockShipmentPage",
      options: {
        mode: "new", load: false,
        onMount: 'collapse',
        resizeable: true
      },
    }
  },
  {
    path: "/inventory/shipment/:id",
    element: Page,
    props: {
      type: "stockShipmentPage",
      options: {
        mode: "edit", load: true,
        onMount: 'collapse',
        resizeable: true
      },
    }
  },
  {
    path: "/inventory/receipt",
    element: ListView,
    props: {
      type: "stockReceiptList",
    }
  },
  {
    path: "/inventory/receipt/newFromPO",
    element: StepView,
    props: {
      type: "stockReceiptWizard"
    }
  },
  {
    path: "/inventory/receipt/newFromPO/:id",
    element: StepView,
    props: {
      type: "stockReceiptWizard",
      options: { step: 1 }
    }
  },
  {
    path: "/inventory/receipt/:id",
    element: Page,
    props: {
      type: "stockReceiptPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/reservation/:id",
    element: Page,
    props: {
      type: "reservationPage",
      options: { mode: "edit", load: true },
    }
  },
  // ProductFamily Routes
  {
    path: '/inventory/productFamily',
    element: ListView,
    props: { type: 'productFamilyList' }
  },
  {
    path: '/inventory/productFamily/new',
    element: Page,
    props: { type: 'productFamilyPage', options: { mode: 'new', load: false } }
  },
  {
    path: '/inventory/productFamily/:id',
    element: Page,
    props: { type: 'productFamilyTabPage', options: { mode: 'edit', load: true, onMount: 'collapse' } }
  },

  // BOM Version Routes
  {
    path: '/inventory/product/:id/bomVersion/new',
    element: Page,
    props: { type: 'bomVersionPage', options: { mode: 'new', load: false, createFromEntity: 'product' } }
  },
  {
    path: '/inventory/product/:id/bomVersion/:id2',
    element: Page,
    props: { type: 'bomVersionPage', options: { mode: 'edit', load: true } }
  },

  // Routing Version Routes
  {
    path: '/inventory/product/:id/routingVersion/new',
    element: Page,
    props: { type: 'routingVersionPage', options: { mode: 'new', load: false, createFromEntity: 'product' } }
  },
  {
    path: '/inventory/product/:id/routingVersion/:id2',
    element: Page,
    props: { type: 'routingVersionPage', options: { mode: 'edit', load: true } }
  },

  //Product Group Routes
  {
    path: "/inventory/productGroup",
    element: ListView,
    props: {
      type: "productGroupList"
    }
  },
  {
    path: "/inventory/productGroup/:id",
    element: Page,
    props: {
      type: "productGroupPage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse'
      }
    }
  },
  {
    path: "/inventory/productGroup/new",
    element: Page,
    props: {
      type: "productGroupPage",
      options: { mode: "new" }
    }
  },

  {
    path: "/inventory/settings",
    element: Page,
    props: {
      type: "inventorySettingsPage",
      options: {
        mode: "edit",
        load: true,
        onMount: 'collapse'
      },
    },
  },
  {
    path: "/inventory/ledger",
    element: ListView,
    props: {
      type: "inventoryLedgerList",
    }
  },
  {
    path: "/inventory/ledger/:id",
    element: Page,
    props: {
      type: "inventoryLedgerDetailPage",
      options: { mode: "edit", load: true },
    }
  },
  {
    path: "/inventory/audit",
    element: DrillDownPage,
    props: {
      type: "inventoryAuditView",
    }
  },
];

export default routesInventory;
